import { getLogo } from "../../util/logo/logo";
export const GET_LOGO = "[PORTAL DETAILS ACTIONS] GET_LOGO";
export const RECEIVE_LOGO = "[PORTAL DETAILS ACTIONS] RECEIVE_LOGO";
export const RECEIVE_ACCOUNT_ID = "[PORTAL DETAILS ACTIONS] RECEIVE_ACCOUNT_ID";
export const FETCH_ERROR = "[PORTAL DETAILS ACTIONS] FETCH_ERROR";


export const receiveLogo = logoUrl => ({
    type: RECEIVE_LOGO,
    payload: logoUrl
});
export const receiveAccountID = logoUrl => ({
    type: RECEIVE_ACCOUNT_ID,
    payload: logoUrl
});

export const fetchError = () => ({
    type: FETCH_ERROR
});

export const fetchLogo = (grablogoparams) => dispatch => {
    getLogo(grablogoparams).then(res => {
        dispatch(receiveLogo(res.data.url));
        if (res.data.accountId) {
            dispatch(receiveAccountID(res.data.accountId));
        }
    }).catch((error) => dispatch(fetchError()));
}